import { Button } from "@web/components/ui/button";
import { useLanguage } from "@web/lib/contexts/language-context";
import { AnimatePresence, motion } from "framer-motion";
import { AlertTriangle, RefreshCw } from "lucide-react";

type CameraStreamErrorOverlayProps = {
	visible: boolean;
	message: string;
	onRetry: () => void;
};

export const CameraStreamErrorOverlay = ({
	visible,
	message,
	onRetry,
}: CameraStreamErrorOverlayProps) => {
	const { t } = useLanguage();

	return (
		<AnimatePresence>
			{visible && (
				<motion.div
					className="absolute z-20 flex max-w-xs flex-col items-center justify-center gap-4 rounded-3xl border border-white/10 bg-zinc-900/90 p-8 text-white shadow-2xl backdrop-blur-md"
					initial={{ opacity: 0, scale: 0.95 }}
					animate={{ opacity: 1, scale: 1 }}
					exit={{ opacity: 0, scale: 0.95 }}
				>
					<div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-500/10">
						<AlertTriangle className="h-8 w-8 text-red-500" />
					</div>
					<div className="text-center">
						<h3 className="mb-2 text-lg font-bold">{t.camera.error}</h3>
						<p className="mb-5 text-sm text-zinc-400">{message}</p>
						<Button
							onClick={onRetry}
							variant="outline"
							className="border-white/20 bg-transparent text-white hover:bg-white/10"
						>
							<RefreshCw className="mr-2 h-4 w-4" />
							{t.common.retry}
						</Button>
					</div>
				</motion.div>
			)}
		</AnimatePresence>
	);
};
